import { render, staticRenderFns } from "./DocumentsSetups.vue?vue&type=template&id=52b1e308"
import script from "./DocumentsSetups.vue?vue&type=script&lang=js"
export * from "./DocumentsSetups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports